import Vue from 'vue';
import VueRouter from 'vue-router';
import { setUserInfo, getUserInfo } from '@/utils/userInfo';
import { isInnerYueyue } from '@/utils/tool';

Vue.use(VueRouter);

let routes = [];

const routerContext = require.context('../pages', true, /_router\.js$/);
routerContext.keys().forEach((route) => {
  const routerModule = routerContext(route);
  /**
   * 兼容 import export 和 require module.export 两种规范
   */
  routes = [...routes, ...(routerModule.default || routerModule)];
});

const router = new VueRouter({
  routes
});

let isInnerApp = isInnerYueyue();
router.beforeEach(async (to, from, next) => {
  try {
    if (isInnerApp) {
      if (Object.keys(getUserInfo()).length) {
        return;
      }
      await setUserInfo();
    }
  } finally {
    window.scrollTo(0, 0);
    next();
  }
});
export default router;
